import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaLinkedin, FaFacebookF, FaGoogle } from "react-icons/fa";
import { useDispatch } from "react-redux";

import { login } from "../../redux/reducers/user";
import { saveState } from "../../utils/useLocalStorage";
import useInput from "../../utils/useInput";

const LoginForm = () => {
  const dispatch = useDispatch();
  const [email, bindEmail] = useInput("");
  const [password, bindPassword] = useInput("");

  const [message, setMessage] = useState(null);
  let navigate = useNavigate();

  const FormSubmitHandler = async function (e) {
    e.preventDefault();
    let form = { email, password };

    await fetch("https://atease-insurance.herokuapp.com/user/login", {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status === "FAILED") {
          setMessage(data.message);
          setTimeout(() => {
            setMessage(null);
          }, 3000);
        } else {
          if (data.user.verified === true) {
            setMessage(data.message);
            // Use redux to store the user
            dispatch(login(data.user));
            saveState("user", data.user);
            setTimeout(() => {
              navigate("/dashboard");
            }, 2000);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <div className="limiter mt-vh-20">
        <div className="container-login100">
          <div className="wrap-login100">
            <form
              onSubmit={FormSubmitHandler}
              className="login100-form validate-form"
            >
              <span className="login100-form-title">Login</span>

              <div
                className="wrap-input100 validate-input"
                data-validate="Email is required"
              >
                <span className="label-input100">Email</span>
                <input
                  className="input100"
                  type="text"
                  placeholder="Type your email"
                  {...bindEmail}
                />
                <span className="focus-input100 email"></span>
              </div>

              <div
                className="wrap-input100 validate-input"
                data-validate="Password is required"
              >
                <span className="label-input100">Password</span>
                <input
                  className="input100"
                  type="password"
                  placeholder="Type your password"
                  {...bindPassword}
                  autoComplete="on"
                />
                <span className="focus-input100 lock"></span>
              </div>

              {message && <p className="text-center p-t-100">{message}</p>}

              <div className="text-right p-t-100">
                <Link to="/forgotpassword">Forgot password?</Link>
              </div>

              <div className="container-login100-form-btn p-t-100">
                <div className="wrap-login100-form-btn">
                  <div className="login100-form-bgbtn"></div>
                  <button className="login100-form-btn">Login</button>
                </div>
              </div>

              <div className="txt1 text-center p-t-100">
                <span>Or sign up using</span>
              </div>

              <div className="flex-c-m">
                <Link to="#" className="login100-social-item bg1">
                  <FaFacebookF />
                </Link>

                <Link to="#" className="login100-social-item bg2">
                  <FaGoogle />
                </Link>

                <Link to="#" className="login100-social-item bg3">
                  <FaLinkedin />
                </Link>
              </div>

              <div className="flex-col-c p-t-100">
                <span className="txt1 p-b-17">Don't have an account?</span>

                <Link to="/register" className="txt2">
                  Register
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
